// extracted by mini-css-extract-plugin
module.exports = {"steps":"recipe-steps-module--steps--1By0L","step":"recipe-steps-module--step--1-Ize","active":"recipe-steps-module--active--24p9d"};